import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  strSortAsc,
  strSortDesc,
  numSortAsc,
  numSortDesc,
  sizeSortAsc,
  sizeSortDesc,
} from 'utils/sortUtils';

const TableContext = React.createContext({ setTableData: (a, b) => {} });

export const TableContextProvider = ({ children }) => {
  const [tableFunc, setTableFunc] = useState({
    valueFunc: (colKey, row) => {},
  });

  const [sortField, setSortField] = useState({ key: '', order: 'asc' });
  const [rows, setRows] = useState([]);
  const [cols, setCols] = useState([]);

  const [selectedRows, setSelectedRows] = useState([]);
  const setTableData = ({ rows: r, cols: c, sortCol, valueFunc }) => {
    setRows(r);
    setCols(c);

    if (sortCol) setSortField(sortCol);

    if (valueFunc) setTableFunc({ valueFunc });
  };

  const toggleRowSelection = (key) => {
    setSelectedRows((prev) =>
      prev.includes(key) ? prev.filter((x) => x !== key) : [...prev, key],
    );
  };

  const getSelectedValue = (key) => {
    return selectedRows.includes(key);
  };

  const sortFunc = (type, order) => {
    switch (type) {
      case 'string':
        return order === 'asc' ? strSortAsc : strSortDesc;
      case 'number':
        return order === 'asc' ? numSortAsc : numSortDesc;

      case 'size':
        return order === 'asc' ? sizeSortAsc : sizeSortDesc;

      default:
        return (a, b) => {
          return 0;
        };
    }
  };

  useEffect(() => {
    const { key, order } = sortField;
    if (!key) return;

    const col = cols.find((c) => c.key === key);
    const { type } = col;

    const sortingAlgorithm = sortFunc(type, order);

    const d = rows.sort((a, b) => {
      const avalue = tableFunc.valueFunc(key, a);
      const bvalue = tableFunc.valueFunc(key, b);
      const res = sortingAlgorithm(avalue, bvalue);

      return res;
    });
    setRows([...d]);
  }, [sortField]);

  const toggleSortOrder = () => {
    const { key, order } = sortField;
    const newOrder = order === 'asc' ? 'desc' : 'asc';
    setSortField({ key, order: newOrder });
  };

  return (
    <TableContext.Provider
      value={{
        rows,
        cols,
        sortField,
        setTableData,
        setSortField,
        toggleSortOrder,
        selectedRows,
        toggleRowSelection,
        getSelectedValue,
      }}
    >
      {children}
    </TableContext.Provider>
  );
};

TableContextProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default TableContext;
